import { NB } from '@cerebral-inc/ui';
import parse from 'html-react-parser';
import { getStaticFilePath } from 'components/shared/utils';
import CheckItem, { CheckItemProps } from './CheckItem';
import Capsule from './images/capsule.svg';
import { SubscriptionWrapper } from './styled';

const { Flex, Box, Center, Text, Image } = NB;

export interface ImageTextLeftProps {
  texts: CheckItemProps[];
  subscription: string;
  image: string;
}

const ImageTextLeft = ({ texts, subscription, image }: ImageTextLeftProps) => {
  return (
    <Flex pb={{ base: '64px', sm: '96px' }} alignItems="center">
      <Center maxW={{ base: '100%', lg: '1264px' }} px="24px">
        <Flex
          flexDir={{ base: 'column', lg: 'row' }}
          alignItems="center"
          justifyContent="space-between"
        >
          <Box w={{ base: '100%', lg: '50%' }}>
            <Box maxW={{ base: '100%', lg: 'calc(100% - 64px)' }}>
              {texts.map(({ title, description }) => (
                <CheckItem
                  title={title}
                  description={description}
                  key={title}
                />
              ))}

              <SubscriptionWrapper>
                <Box w="24px">
                  <Image
                    src={getStaticFilePath(Capsule)}
                    w="24px"
                    h="24px"
                    alt="icon-capsule"
                  />
                </Box>
                <Text
                  color="#250044"
                  fontSize="14px"
                  lineHeight="24px"
                  ml="16px"
                  fontFamily="Poppins"
                >
                  {parse(subscription)}
                </Text>
              </SubscriptionWrapper>
            </Box>
          </Box>
          <Flex
            w={{ base: '100%', lg: '50%' }}
            mt={{ base: '48px', lg: 0 }}
            justifyContent="center"
            alignItems="center"
            h={{ base: '240px', sm: '400px', lg: '580px' }}
          >
            <img
              height="100%"
              src={getStaticFilePath(image)}
              alt=""
              width="100%"
              style={{ objectFit: 'cover' }}
            />
          </Flex>
        </Flex>
      </Center>
    </Flex>
  );
};

export default ImageTextLeft;
